/* MCR home-page section components (vanilla web components, no deps).
   mcr-tabs · mcr-carousel · mcr-countdown · mcr-countup · mcr-draw · mcr-hotspots · mcr-readmore · mcr-tilt */
(function () {
  'use strict';
  if (window.__mcrSections) return;
  window.__mcrSections = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var anim = function () { return document.documentElement.classList.contains('mcr-anim') && !reduce; };
  function define(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }

  /* ---------- Tabs (featured products) ---------- */
  class McrTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = this.tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
      this.links = Array.prototype.slice.call(this.querySelectorAll('[data-tab-link]'));
      var self = this;
      this.tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { self.select(i, false); });
        tab.addEventListener('keydown', function (e) {
          var n = self.tabs.length, k = -1;
          if (e.key === 'ArrowRight') k = (i + 1) % n;
          else if (e.key === 'ArrowLeft') k = (i - 1 + n) % n;
          else if (e.key === 'Home') k = 0;
          else if (e.key === 'End') k = n - 1;
          if (k > -1) { e.preventDefault(); self.select(k, true); }
        });
      });
      this.moveInk(0);
      window.addEventListener('resize', function () { self.moveInk(self.current || 0); }, { passive: true });
      // build the other tabs' products as soon as the shopper heads for the tabs
      var list = this.querySelector('[role="tablist"]');
      var warm = function () { self.panels.forEach(function (p) { self.hydrate(p); }); };
      if (list) ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { list.addEventListener(ev, warm, { once: true, passive: true }); });
    }
    hydrate(p) {
      var t = p && p.querySelector('template[data-mcr-lazy-panel]');
      if (!t) return;
      p.appendChild(t.content.cloneNode(true));
      t.remove();
      if (window.MCR && window.MCR.init) window.MCR.init(p);
      if (window.MCR && window.MCR.wishlistSync) window.MCR.wishlistSync();
    }
    select(i, focus) {
      this.current = i;
      this.hydrate(this.panels[i]);
      this.tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-active', on);
      });
      this.panels.forEach(function (p, k) { if (p) { p.hidden = k !== i; if (k === i) { p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); } } });
      this.links.forEach(function (l, k) { l.hidden = k !== i; });
      if (focus) this.tabs[i].focus();
      this.moveInk(i);
      if (window.MCR && this.panels[i]) window.MCR.init(this.panels[i]);
    }
    moveInk(i) {
      var ink = this.querySelector('.mcr-tabs__ink');
      var t = this.tabs[i];
      if (!ink || !t) return;
      ink.style.transform = 'translateX(' + t.offsetLeft + 'px)';
      ink.style.width = t.offsetWidth + 'px';
      if (t.offsetWidth) ink.parentElement.classList.add('has-ink');
    }
  }
  define('mcr-tabs', McrTabs);

  /* ---------- Carousel: wraps a .mcr-scroller with [data-prev]/[data-next], optional autoplay ---------- */
  class McrCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]') || this.querySelector('.mcr-scroller');
      if (!this.track) return;
      var self = this;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (this.prev) this.prev.addEventListener('click', function () { self.step(-1); });
      if (this.next) this.next.addEventListener('click', function () { self.step(1); });
      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { self.update(); ticking = false; });
      }, { passive: true });
      this.update();
      var delay = parseInt(this.dataset.autoplay, 10);
      if (delay > 0 && !reduce && !(window.Shopify && window.Shopify.designMode)) {
        this.paused = false;
        ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { self.addEventListener(ev, function () { self.paused = true; }, { passive: true }); });
        ['mouseleave', 'focusout'].forEach(function (ev) { self.addEventListener(ev, function () { self.paused = false; }); });
        this.visible = false;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (en) { self.visible = en[0].isIntersecting; }).observe(this);
        }
        this.timer = setInterval(function () {
          if (self.paused || !self.visible || document.hidden) return;
          var max = self.track.scrollWidth - self.track.clientWidth;
          if (self.track.scrollLeft >= max - 4) self.track.scrollTo({ left: 0, behavior: 'smooth' });
          else self.step(1);
        }, delay * 1000);
      }
    }
    disconnectedCallback() { if (this.timer) clearInterval(this.timer); }
    step(dir) {
      var item = this.track.firstElementChild;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      var w = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
      var per = Math.max(1, Math.floor((this.track.clientWidth + gap) / w));
      this.track.scrollBy({ left: dir * w * per, behavior: reduce ? 'auto' : 'smooth' });
    }
    update() {
      var max = this.track.scrollWidth - this.track.clientWidth;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 4;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 4;
      this.classList.toggle('is-scrollable', max > 4);
    }
  }
  define('mcr-carousel', McrCarousel);

  /* ---------- Countdown: <mcr-countdown data-end="2026-11-08T23:59:00+05:30"> ---------- */
  class McrCountdown extends HTMLElement {
    connectedCallback() {
      // Manual parse (Safari-safe): "YYYY-MM-DD[ HH:mm[:ss]]" interpreted as IST (UTC+05:30)
      var m = (this.dataset.end || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
      if (!m) { this.hidden = true; return; }
      var hasTime = m[4] !== undefined;
      this.end = Date.UTC(+m[1], +m[2] - 1, +m[3], hasTime ? +m[4] : 23, hasTime ? +m[5] : 59, m[6] ? +m[6] : (hasTime ? 0 : 59)) - 330 * 60000;
      this.units = {
        d: this.querySelector('[data-d]'), h: this.querySelector('[data-h]'),
        m: this.querySelector('[data-m]'), s: this.querySelector('[data-s]'),
      };
      var self = this;
      this.tick();
      this.timer = setInterval(function () { self.tick(); }, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      var diff = Math.max(0, this.end - Date.now());
      var s = Math.floor(diff / 1000);
      var vals = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      for (var k in vals) if (this.units[k]) this.units[k].textContent = String(vals[k]).padStart(2, '0');
      if (diff <= 0) { clearInterval(this.timer); this.classList.add('is-ended'); }
    }
  }
  define('mcr-countdown', McrCountdown);

  /* ---------- Count-up stats: children [data-count-to] ---------- */
  class McrCountup extends HTMLElement {
    connectedCallback() {
      var els = Array.prototype.slice.call(this.querySelectorAll('[data-count-to]'));
      if (!els.length || !anim() || !('IntersectionObserver' in window)) return;
      var fmt = function (n, dec) {
        return Number(n).toLocaleString('en-IN', { minimumFractionDigits: dec, maximumFractionDigits: dec });
      };
      els.forEach(function (el) { el.textContent = fmt(0, parseInt(el.dataset.decimals || 0, 10)); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          var el = entry.target;
          var to = parseFloat(el.dataset.countTo) || 0;
          var dec = parseInt(el.dataset.decimals || 0, 10);
          var dur = 1800, t0 = performance.now();
          (function frame(now) {
            var p = Math.min(1, (now - t0) / dur);
            var e = 1 - Math.pow(1 - p, 4);
            el.textContent = fmt(to * e, dec);
            if (p < 1) requestAnimationFrame(frame);
          })(t0);
        });
      }, { threshold: 0.6 });
      els.forEach(function (el) { io.observe(el); });
    }
  }
  define('mcr-countup', McrCountup);

  /* ---------- Line-drawing SVGs tied to scroll progress (sets --mcr-draw 0..1) ---------- */
  class McrDraw extends HTMLElement {
    connectedCallback() {
      if (!anim()) { this.style.setProperty('--mcr-draw', 1); return; }
      this.classList.add('is-drawing');
      var self = this, active = false, ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var r = self.getBoundingClientRect();
          var vh = window.innerHeight || 1;
          // 0 when the top enters the bottom of the viewport, 1 when element centre reaches ~40% of viewport
          var p = (vh - r.top) / (vh * 0.6 + r.height * 0.5);
          p = Math.max(0, Math.min(1, p));
          self.style.setProperty('--mcr-draw', p.toFixed(3));
        });
      };
      this._onScroll = onScroll;
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (en) {
          var on = en[0].isIntersecting;
          if (on && !active) { window.addEventListener('scroll', onScroll, { passive: true }); active = true; onScroll(); }
          else if (!on && active) { window.removeEventListener('scroll', onScroll); active = false; }
        });
        this.io.observe(this);
      } else this.style.setProperty('--mcr-draw', 1);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
    }
  }
  define('mcr-draw', McrDraw);

  /* ---------- Lookbook hotspots ---------- */
  class McrHotspots extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-hotspot]'));
      this.buttons.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = b.getAttribute('aria-expanded') === 'true';
          self.closeAll();
          if (!open) self.open(b);
        });
      });
      this.querySelectorAll('[data-hotspot-trigger]').forEach(function (t) {
        var target = self.querySelector('#' + t.getAttribute('data-hotspot-trigger'));
        t.addEventListener('mouseenter', function () { if (target) { self.closeAll(); self.open(target); } });
        t.addEventListener('focus', function () { if (target) { self.closeAll(); self.open(target); } });
      });
      this._doc = function (e) { if (!self.contains(e.target) || !e.target.closest('.mcr-look__pop')) self.closeAll(); };
      this._key = function (e) { if (e.key === 'Escape') { var b = self.querySelector('[data-hotspot][aria-expanded="true"]'); self.closeAll(); if (b) b.focus(); } };
      document.addEventListener('click', this._doc);
      document.addEventListener('keydown', this._key);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._doc);
      document.removeEventListener('keydown', this._key);
    }
    open(b) {
      b.setAttribute('aria-expanded', 'true');
      var pop = document.getElementById(b.getAttribute('aria-controls'));
      if (pop) pop.hidden = false;
      var item = this.querySelector('[data-hotspot-trigger="' + b.id + '"]');
      if (item) item.classList.add('is-active');
    }
    closeAll() {
      var self = this;
      this.buttons.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var pop = document.getElementById(b.getAttribute('aria-controls'));
        if (pop) pop.hidden = true;
      });
      this.querySelectorAll('[data-hotspot-trigger].is-active').forEach(function (i) { i.classList.remove('is-active'); });
      void self;
    }
  }
  define('mcr-hotspots', McrHotspots);

  /* ---------- Read more (SEO intro); waits until its <details> is opened before measuring ---------- */
  class McrReadmore extends HTMLElement {
    connectedCallback() {
      var self = this;
      var d = this.closest('details');
      if (d && !d.open) {
        var onToggle = function () { if (d.open) { d.removeEventListener('toggle', onToggle); self.setup(); } };
        d.addEventListener('toggle', onToggle);
        return;
      }
      this.setup();
    }
    setup() {
      if (this.ready) return;
      this.ready = true;
      var body = this.querySelector('[data-readmore-body]');
      var btn = this.querySelector('[data-readmore-toggle]');
      if (!body || !btn) return;
      var limit = parseInt(this.dataset.height || '160', 10);
      if (body.scrollHeight <= limit + 40) { btn.hidden = true; return; }
      this.classList.add('is-collapsible');
      var label = btn.querySelector('[data-label]') || btn;
      btn.hidden = false;
      body.style.maxHeight = limit + 'px';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        label.textContent = open ? btn.dataset.more : btn.dataset.less;
        body.style.maxHeight = open ? limit + 'px' : body.scrollHeight + 'px';
        body.classList.toggle('is-open', !open);
      });
    }
  }
  define('mcr-readmore', McrReadmore);

  /* ---------- SEO accordion: one <details> bar that also shows/hides follower sections with the same key ---------- */
  class McrSeoAccordion extends HTMLElement {
    connectedCallback() {
      var self = this;
      var d = this.querySelector('details');
      if (!d) return;
      var key = this.dataset.key;
      this._sync = function () {
        var f = document.querySelectorAll('[data-seo-follow="' + key + '"]');
        self.classList.toggle('has-followers', f.length > 0);
        self.classList.toggle('is-open', d.open);
        Array.prototype.forEach.call(f, function (el) { el.classList.toggle('is-collapsed', !d.open); });
      };
      d.addEventListener('toggle', this._sync);
      document.addEventListener('shopify:section:load', this._sync);
      this._sync();
    }
    disconnectedCallback() { document.removeEventListener('shopify:section:load', this._sync); }
  }
  define('mcr-seo-accordion', McrSeoAccordion);

  /* ---------- Parallax-lite hover tilt for promo tiles ---------- */
  class McrTilt extends HTMLElement {
    connectedCallback() {
      if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var self = this, media = this.querySelector('[data-tilt-media]'), raf = 0;
      if (!media) return;
      this.addEventListener('pointermove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = self.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          media.style.transform = 'scale(1.08) translate3d(' + (-x * 18).toFixed(1) + 'px,' + (-y * 18).toFixed(1) + 'px,0)';
        });
      });
      this.addEventListener('pointerleave', function () { media.style.transform = ''; });
    }
  }
  define('mcr-tilt', McrTilt);
})();
